import { buildProps } from '@jdesign-vue/utils'

// import { dialogProps } from '../../dialog/src/dialog'

import type { ExtractPropTypes, PropType } from 'vue'

import type ResultDialog from './result-dialog.vue'

export const resultDialogProps = buildProps({
  resultProps: {
    type: Object as PropType<{
      title?: string
      subTitle?: string
      icon?: 'success' | 'warning' | 'info' | 'error'
    }>,
    default: () => ({
      title: '',
      subTitle: '',
      icon: 'info',
    }),
  },
  dialogProps: {
    type: Object,
    default: () => ({}),
  },
} as const)

export type ResultDialogProps = ExtractPropTypes<typeof resultDialogProps>

export type ResultDialogInstance = InstanceType<typeof ResultDialog>
